import { RouterProvider } from 'react-router-dom';
import { withProfiler } from '@sentry/react';
import { ChatApiClientProvider } from '@/containers/ChatCompatability/ChatApiClientProvider';
import { createRouter } from '@/router';
import { AppInitializing } from '@/screens/Initializing';

import '@/static/css/global/style.css';

const router = createRouter();

const UnprofiledApp = () => {

  return (
    <ChatApiClientProvider>
      <RouterProvider
        router={router}
        fallbackElement={<AppInitializing />}
        future={{
          v7_startTransition: true,
        }}
      />
    </ChatApiClientProvider>
  );
};

export const App = withProfiler(UnprofiledApp);